import { render, staticRenderFns } from "./CaseCode.vue?vue&type=template&id=ed62b808"
import script from "./CaseCode.vue?vue&type=script&lang=js"
export * from "./CaseCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports